import { createFileRoute, Link } from "@tanstack/react-router";
import { PageHeader, EmptyState } from "@/components/PageStates";
import { Progress } from "@/components/ui/progress";
import { wishes, child } from "@/lib/mock-data";

export const Route = createFileRoute("/app/wishes")({
  component: WishList,
});

const statusLabel: Record<string, { text: string; bg: string; fg: string }> = {
  redeemable: { text: "可兑换", bg: "var(--accent-soft)", fg: "var(--accent)" },
  reached: { text: "已达成", bg: "var(--warn-soft)", fg: "var(--warn-fg)" },
  fulfilled: { text: "已完成", bg: "var(--surface-2)", fg: "var(--muted)" },
  cancelled: { text: "已取消", bg: "var(--surface-2)", fg: "var(--muted)" },
};

function WishList() {
  return (
    <div>
      <PageHeader title="心愿" />
      <div className="px-4 pt-4">
        {wishes.length === 0 ? (
          <EmptyState
            title="还没有心愿"
            hint="请在电脑端管理页面添加心愿。"
          />
        ) : (
          <ul className="space-y-3">
            {wishes.map((w) => {
              const pct = Math.min(100, (child.availablePoints / w.required) * 100);
              const s = statusLabel[w.status];
              return (
                <li key={w.id}>
                  <Link
                    to="/app/wishes/$id"
                    params={{ id: w.id }}
                    className="block rounded-[var(--r-lg)] border bg-surface p-4"
                  >
                    <div className="flex items-start justify-between gap-3">
                      <div className="min-w-0">
                        <p className="truncate text-[var(--fs-md)] font-semibold">
                          {w.title}
                        </p>
                        <p
                          className="mt-0.5 text-[var(--fs-xs)]"
                          style={{ color: "var(--muted)" }}
                        >
                          {w.category} · 需要 {w.required} 分
                        </p>
                      </div>
                      <span
                        className="shrink-0 rounded-full px-2 py-0.5 text-[var(--fs-xs)]"
                        style={{ background: s.bg, color: s.fg }}
                      >
                        {s.text}
                      </span>
                    </div>
                    <div className="mt-3 flex items-center gap-3">
                      <Progress value={pct} className="h-1.5 flex-1" />
                      <span
                        className="shrink-0 text-[var(--fs-xs)]"
                        style={{ color: "var(--muted)" }}
                      >
                        {child.availablePoints}/{w.required}
                      </span>
                    </div>
                  </Link>
                </li>
              );
            })}
          </ul>
        )}
      </div>
    </div>
  );
}
